export default import.meta.ROLLDOWN_FILE_URL_pLhid3d$elTFKdZ4iiTEbA